import React from 'react'
import ModalClub from '../../components/modals/ModalClub';
import MicroModal from 'micromodal';
import { useState } from "react";
import useIsMobile from "../../js/utilities/useIsMobile";
import PropTypes from "prop-types";

/**
 * Este componente renderiza la segunda sección del club MakeMake que corresponde a la información sobre los planes de lecturas 
 * y recibe como props los textos de la interfaz. Se hace uso del componente ModalClub para la visualización de PDF.
 */

const PlanLectura = (props) => {

    const { traducciones } = props;
    const [anio, setAnio] = useState();
    const [rutaPDF, setRutaPDF] = useState();
    const [fileName, setFileName] = useState();
    const isMobile = useIsMobile();

    /**
     * Esta función define si el tamaño de la pantalla es de un dispositivo de escritorio los botones planes de lectura despliegan una ventana modal donde se pueden 
     * pre visualizar los archivos PDF, en cambio, si la pantalla es de un dispositivo móvil la pre visualización se desactiva y pasa a ser un botón para descargar el archivo PDF.
     * @param {string} ruta - ruta del archivo PDF
     * @param {string} file - nombre del archivo PDF 
     * @param {string} date - año del plan de lectura
     */

    const botonDescarga = (ruta, file, date) => {
        if (isMobile) {
            let alink = document.createElement('a');
            alink.href = ruta;
            alink.setAttribute("download", file);
            document.body.appendChild(alink);
            alink.click();
            alink.remove();
        }
        else {
            MicroModal.show("modal-club", {
                awaitCloseAnimation: true,
            });
            setAnio(date)
            setRutaPDF(ruta)
            setFileName(file)
        }
    }

    return (
        <div className="seccion-morado-claro pt-5" id="plan-acompanamiento">
            <div className="container">
                <div className=" col-lg-10 mx-auto">
                    <div className="row mx-0 justify-content-center">
                        <div className='col-12 px-0 px-sm-4 col-sm-9'>
                            <div className="d-xl-flex align-items-center pt-3 pt-lg-0">
                                <span className='numero-titles-morado titulo-morado-act d-flex justify-content-center px-4 align-items-center mx-auto mx-xl-0'>1</span>
                                <h2 className="titulos-actualizacion-club titulo-morado-act mx-0 mx-xl-3 text-center text-xl-left ">{traducciones?.titulo || 'Plan de lecturas MakeMake'}</h2>
                            </div>
                        </div>
                        {/*Primera seccion*/}
                        <div className="col-lg-8 col-md-10 pt-3 justify-content-center align-items-center">
                            <p className="titulo-plan-lecturas px-0 px-xl-5 text-center text-lg-left" ><img src="/img/club-makemake/icon-1.png" className="img-fluid " />{traducciones?.fecha || 'Febrero 2023 a Enero 2024'}</p>
                        </div>
                        <div className="col-lg-9 py-5">
                            <p className='px-4 px-lg-2 parrafo-acompanamiento onbackground-third--color'>
                                {traducciones?.parrafo_1 || 'Acompañamiento lector a lo largo del año que propone abrir espacios de conversación y discusión. Cada mes presentaremos una pregunta acompañada de palabras o conceptos claves, 3 libros recomendados los cuales contarán con su respectiva actividad y una lista de libros asociados. Esta información se enviará a nuestros suscriptores mes a mes por medio de nuestros boletines especializados.'}
                            </p>
                        </div>

                        {/*Segunda seccion*/}
                        <div className="col-lg-9 px-4">
                            <div className="row mx-0 justify-content-around pb-5">
                                <div className="contenedor-icon d-flex flex-column px-0">
                                    <div className="icon-lecturas-act icon-libros mx-auto "></div>
                                    <div className='texto-icon d-flex align-items-end'>
                                        <p className="fuente-bold-act px-1 pt-5 pb-3 py-md-3 py-lg-4 text-center">{traducciones?.caracteristicas?.boletines || '11 boletines especializados'}</p>
                                    </div>
                                </div>
                                <div className="contenedor-icon d-flex flex-column px-0">
                                    <div className="icon-lecturas-act icon-libro mx-auto "></div>
                                    <div className='texto-icon d-flex align-items-end'>
                                        <p className="fuente-bold-act px-1 pt-5 pb-3 py-md-3 py-lg-4 text-center">{traducciones?.caracteristicas?.libros || '36 libros recomendados'}</p>
                                    </div>
                                </div>
                                <div className="contenedor-icon d-flex flex-column px-0">
                                    <div className="icon-lecturas-act icon-libreta mx-auto "></div>
                                    <div className='texto-icon d-flex align-items-end'>
                                        <p className="fuente-bold-act px-1 pt-5 pb-3 py-md-3 py-lg-4 text-center">{traducciones?.caracteristicas?.actividades || '36 actividades asociadas'}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/*Tercer seccion*/}
                        <div className='row col-lg-9 justify-content-around pb-5'>
                            <div className='text-descargar col-12 col-md-6'>
                                <p className='text-center text-md-left pb-5 pb-md-0'>
                                    {traducciones?.descarga?.parrafo_descarga || 'Descarga el plan completo del 2023 y programa tus lecturas con MakeMake'}
                                </p>
                            </div>
                            <div className='col-12 col-md-6 d-flex align-items-center pb-3 pb-md-0'>
                                <a
                                    href={traducciones?.link_plan_lecturas || "/document/plan_lecturas_2023_act.pdf"}
                                    download={traducciones?.descarga?.boton_descarga || 'Plan lecturas 2023'}
                                    className='btn-descargar-act col-lg-12 py-2 focusable-red mx-auto d-block'
                                >
                                    {traducciones?.descarga?.boton_descarga || 'Plan lecturas 2023'}
                                </a>
                            </div>
                        </div>
                        {/*Cuarta seccion*/}
                        <div className="col-lg-8 px-3 pb-5">
                            <p className="texto-especificacion-act"><span>{traducciones?.disponible?.uno || '* Disponible solo para suscriptores institucionales.'}</span> {traducciones?.disponible?.dos || 'Si tu colegio o biblioteca hace parte de MakeMake tendrás acceso a los libros recomendados durante el mes que estén anunciados.'}</p>
                        </div>
                        {/*Quinta seccion*/}
                        <div className="col-lg-9 px-2 onbackground-third--color">
                            <p className='titulo-planes titulo-rojo-act pb-5'>
                                {traducciones?.subtitulo || 'Planes anteriores:'}
                            </p>
                            <strong>
                                {traducciones?.parrafo_2 || 'Conoce los planes lectores de años pasados, los cuales también pueden ser una guía para trabajar diversos temas y libros. Todos los libros que han sido recomendados del mes tienen actividad.'}
                            </strong>
                        </div>
                        {/*Sexta seccion*/}
                        <div className=" row col-lg-9 px-0 justify-content-center">
                            <div className="col-12 col-xl-7 d-flex align-items-center">
                                <img alt="monstar-planes" src="/img/club-makemake/monster-planes.png" className="img-fluid pt-5 pt-xl-0 d-none d-sm-block background-contraste" />
                            </div>
                            <div className="d-md-flex d-xl-block col-xl-5 col-lg-12 py-5">
                                <div className="col-xl-10 col-md-4 col-sm-6 col-8 pb-5 px-xl-3 mx-auto">
                                    <button
                                        onClick={() => {
                                            botonDescarga("/document/plan_lecturas_2020_act.pdf", "plan_lecturas_2020.pdf", "2020")
                                        }}
                                        className="div-planes py-2 px-2 d-block mx-auto text-center focusable-red"
                                    >
                                        {traducciones?.botones_planes?.planes_text?.texto || 'Plan lecturas '} <span>2020</span>
                                        <div className='boton-abre-modal '>
                                            <i className='icono-fa fas fa-plus fa-2x fa-fw'></i>
                                        </div>
                                    </button>

                                </div>
                                <div className="col-xl-10 col-md-4 col-sm-6 col-8 pb-5 px-xl-3 pt-xl-3 mx-auto">
                                    <button
                                        onClick={() => {
                                            botonDescarga("/document/plan_lecturas_2021_act.pdf", "plan_lecturas_2021.pdf", "2021")
                                        }}
                                        className="div-planes py-2 px-2 d-block mx-auto text-center focusable-red"
                                    >
                                        {traducciones?.botones_planes?.planes_text?.texto || 'Plan lecturas '} <span>2021 </span>
                                        <div className='boton-abre-modal'>
                                            <i className='icono-fa fas fa-plus fa-2x fa-fw'></i>
                                        </div>
                                    </button>

                                </div>
                                <div className="col-xl-10 col-md-4 col-sm-6 col-8 pb-5 px-xl-3 pt-xl-3 mx-auto">
                                    <button
                                        onClick={() => {
                                            botonDescarga(traducciones?.plan_2022?.link_descarga || "/document/plan_lecturas_2022_act.pdf", traducciones?.plan_2022?.nombre_archivo ||"plan_lecturas_2022.pdf", "2022")
                                        }}
                                        className="div-planes py-2 px-2 d-block mx-auto text-center focusable-red"
                                    >
                                        {traducciones?.botones_planes?.planes_text?.texto || 'Plan lecturas'} <span>2022</span>

                                        <div className='boton-abre-modal'>
                                            <i className='icono-fa fas fa-plus fa-2x fa-fw'></i>
                                        </div>
                                    </button>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <ModalClub texto={traducciones?.botones_planes?.planes_text?.texto} anio={anio} rutaPDF={rutaPDF} fileName={fileName} />
        </div>
    )
}

export default PlanLectura;

PlanLectura.propTypes={
    /**
     * Es un objeto que trae los textos de la interfaz, especificamente los de mi cuenta. Estos cambian dependiendo del idioma activo.
     */
    traducciones: PropTypes.object.isRequired
}